import { Button, Col, Form, Row } from 'antd';
import moment from 'moment';
import React, { forwardRef, Fragment, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';

import { useSearchParams } from '@hooks';
import { emptyFun } from '@untils/common';
import { uiType } from './merge';
import './index.less';

const SearchForm = forwardRef((props, ref) => {
  const {
    schema = [],
    functionMap = {},
    mapName = [],
    searchHook,
    onSearch: propsSearch = emptyFun,
    tab = '',
    width,
    defaultValues = {},
    span = 6,
    // 需要从 URL 参数中过滤掉的 key，排除后这些参数存在时不触发自动 form.submit
    // 用于解决一些列表请求两次接口的问题
    excludeQueryKeys = [],
  } = props;

  // 获取 query 参数
  const searchParams = useSearchParams();
  const [initvalues, setInitvalues] = useState({ ...defaultValues, ...searchParams });
  const [form] = Form.useForm();
  const didInitReset = useRef(false);

  const style = width
    ? {
        flex: `0 0 ${width}`,
        maxWidth: width,
      }
    : {};

  const onFinish = formObj => {
    const result = { ...formObj };

    mapName.forEach(item => {
      const { name, keys = [] } = item;

      // 单独解出来时间类型
      if (formObj[name]) {
        formObj[name].forEach((time, index) => {
          result[keys[index]] = (moment(time).valueOf() / 1000).toFixed(0);
        });
      } else {
        result[keys[0]] = '';
        result[keys[1]] = '';
      }
    });
    propsSearch(result);
  };

  const formDom = useMemo(() => {
    const onSearch = () => {
      form.submit();
    };
    const resetSearch = () => {
      form.resetFields();
      form.submit();
    };
    // 赋初始日期值
    const cb = (name, val) => {
      setInitvalues(prevInitvalues => ({
        ...prevInitvalues,
        [name]: val,
      }));
    };

    const realSchema = schema.filter(item => {
      const { tabs = [] } = item;

      return tabs.length === 0 || tabs.indexOf(tab) > -1;
    });
    const formChilren = realSchema.map((item, index) => {
      return (
        <Col key={index} span={span} style={style}>
          {uiType(item, onSearch, functionMap, cb, form)}
        </Col>
      );
    });

    const formWithReset = (
      <Fragment>
        {formChilren}
        <Col span={span} className="mb-12 search-form-btn">
          <Button type="primary" onClick={resetSearch}>
            重置
          </Button>
          <Button type="primary" onClick={onSearch} className="search-btn">
            查询
          </Button>
        </Col>
      </Fragment>
    );

    return formWithReset;
  }, []);

  useEffect(() => {
    if (didInitReset.current) {
      form.resetFields();
    } else {
      didInitReset.current = true;
    }
  }, [initvalues]);

  // 获取 query 参数后直接进行一次查询
  useEffect(() => {
    // 去掉一些额外参数（有需求时添加更多）
    // 提前预留分页参数 page/page_size
    const baseExclude = ['t', 'inIframe', 'ia_key', 'page', 'page_size'];
    const allExclude = new Set([...baseExclude, ...excludeQueryKeys]);
    // 过滤掉排除的 key
    const filteredEntries = Object.entries(searchParams).filter(([k]) => !allExclude.has(k));
    const filteredObj = Object.fromEntries(filteredEntries);
    // query 参数是否为空：本身为空；所有值都是空字符串也视为空
    const isSearchParamsEmpty = filteredEntries.length === 0 || Object.values(filteredObj).every(val => val === '');

    if (form && (typeof searchHook === 'undefined' || searchHook === -1) && !isSearchParamsEmpty) {
      form.submit();
    }
  }, [searchHook, searchParams, excludeQueryKeys.join(',')]);

  useImperativeHandle(
    ref,
    () => ({
      setFieldsValue: form.setFieldsValue,
    }),
    []
  );

  return (
    <Form className="search-form" onFinish={onFinish} form={form} initialValues={initvalues}>
      <Row>{formDom}</Row>
    </Form>
  );
});

export default SearchForm;
